var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-43.3%",
    y: "-65.4%",
    width: "186.7%",
    height: "252.1%",
    filterUnits: "objectBoundingBox",
    id: "9m0dwoehdb"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-14.8%",
    y: "-16.1%",
    width: "129.6%",
    height: "132.2%",
    filterUnits: "objectBoundingBox",
    id: "fh5tby7jxd"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.917 16.443a3.057 3.057 0 1 0 6.115 0",
    id: "lyrwx3z34a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.908 0a6.694 6.694 0 0 1 6.694 6.694v4.498l2.174 3.75a1 1 0 0 1-.865 1.5H1a1 1 0 0 1-.875-1.484l2.089-3.766V6.694A6.694 6.694 0 0 1 8.908 0z",
    id: "q8aps82qpc"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.848 1.268)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D5DFFE",
    xlinkHref: "#lyrwx3z34a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#9m0dwoehdb)",
    xlinkHref: "#lyrwx3z34a"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#111C5B",
    strokeWidth: 1.3,
    xlinkHref: "#lyrwx3z34a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.848 1.268)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D5DFFE",
    xlinkHref: "#q8aps82qpc"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#fh5tby7jxd)",
    xlinkHref: "#q8aps82qpc"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#111C5B",
    strokeWidth: 1.3,
    xlinkHref: "#q8aps82qpc"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.569f144e0484676f0043bc8a1ada160a.svg";
export { ForwardRef as ReactComponent };